import Vue from 'vue';
import VeeValidate from 'vee-validate';
// import de from 'vee-validate/dist/locale/de';

// de.messages.max_value = (field, [max]) => `${field} muss ${max} oder weniger sein.`;
// de.messages.min_value = (field, [max]) => `${field} muss ${max} oder mehr sein.`;

// Validator.localize('de', de);

Vue.use(VeeValidate, {
    fieldsBagName: 'inputs ', // Default is fields
});

VeeValidate.Validator.extend('verify_password', {
    getMessage: (field) => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. ! @ # $ % ^ & * _ etc)`,
    validate: (value) => {
        var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_])(?=.{8,})');
        return strongRegex.test(value);
    },
});

// TODO Maybe remove this later (It's not used for now)
const extendOptions = {hasTarget: true};

VeeValidate.Validator.extend('timeAfter', {
    getMessage: (field) => `The ${field} must be higher.`,
    validate: (value, [otherValue]) => {
        return new Date('1/1/1999 ' + value) > new Date('1/1/1999 ' + otherValue)
    },
}, extendOptions);

VeeValidate.Validator.extend('timeEqualOrAfter', {
  getMessage: (field) => `The ${field} must be higher.`,
  validate: (value, [otherValue]) => {
    return new Date('1/1/1999 ' + value) >= new Date('1/1/1999 ' + otherValue)
  },
}, extendOptions);